import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const ProductCollectionsFrontend = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const ProductCollections = withAppProviders(ProductCollectionsFrontend)();
export default ProductCollections;

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-product-collections");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<ProductCollections />
			</Suspense>,
			element
		);
	}
});
